import { ButtonHTMLAttributes } from 'react'

import Button from '@/components/base/button'
import Spinner from '@/components/base/spinner'
import TextEffect from '@/components/base/text-effect'
import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'
import { isAcademy } from '@/constants'

import { cn } from '@/lib/utils'

export type LoadMoreProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fetching?: boolean
}

const LoadMoreButton = ({ fetching, ...props }: LoadMoreProps) => {
  const { strings } = useStore()

  return (
    <Button
      isLiquid
      variant="primary"
      endIcon={fetching ? <Spinner variant="small" /> : undefined}
      className={cn([
        'dark flex w-full justify-center',
        { 'pointer-events-none': fetching }
      ])}
      full={isAcademy}
      {...props}
    >
      <TextEffect>
        <Typography variant="regular">{strings?.labels.load_more}</Typography>
      </TextEffect>
    </Button>
  )
}

export default LoadMoreButton
